import { render } from "./SubidaLlamadas.vue?vue&type=template&id=133c9399"
import script from "./SubidaLlamadas.vue?vue&type=script&lang=js"
export * from "./SubidaLlamadas.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__